module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/4-f84bda01864a210d8f488165aa121b9d.png";